import networkAdapter from '../adapters/network';

export const fetchTrialPlacementsByFieldId = ({ userId, fieldId, year, cropName, seasonName }) => {
  const graphRequest = {
    userId,
    query: `
      {
        trialPlacements(fieldId: "${fieldId}", year: ${year}, cropName: "${cropName}", seasonName: ${seasonName}) {
          recommended {
            id
            champion {
              id
              boundary {
                type
                ...on PolygonGeoJSONGeometry {
                  polygonCoordinates:coordinates
                }
                ...on MultiPolygonGeoJSONGeometry {
                  multiPolygonCoordinates:coordinates
                }
              }
              area {
                unit
                value
              }
            }
            challengers {
              id
              boundary {
                type
                ...on PolygonGeoJSONGeometry {
                  polygonCoordinates:coordinates
                }
                ...on MultiPolygonGeoJSONGeometry {
                  multiPolygonCoordinates:coordinates
                }
              }
              area {
                unit
                value
              }
            }
          }
        }
      }
    `,
    variables: {
      fieldId,
      year,
      cropName,
      seasonName
    },
    olVersion: '2'
  };

  return networkAdapter({
    options: graphRequest,
    useOL: true
  });
};
